module.exports = __webpack_public_path__ + "img/Hypoxia-PDAC_GSE205354.8e016a73.png";